import { Component, OnInit } from '@angular/core';
import { Report } from '../../models/index';
import { ResearcherService,  MessageQueService } from '../../services/index';

@Component({
  selector: 'app-wo-report',
  templateUrl: 'WorkOrderReport.component.html',
  styleUrls: ['WorkOrderReport.component.scss'],
  providers: [ResearcherService, MessageQueService]
})

export class WorkOrderReportComponent implements OnInit {
  rpt: Report[] = [];
  endOfFile: number;
  jurisdiction: string;
  showJuris: boolean;
  isPageBreak: boolean;
  requestNbr: string;

  constructor(private researcherService: ResearcherService, private msgSvc: MessageQueService) {
    this.requestNbr = JSON.parse(localStorage.getItem('requests'));
  }

  ngOnInit() {
    this.msgSvc.setControlKey();
    this.getReportData(this.requestNbr);
  }
  getReportData(requestNbrs: any) {
    this.rpt.length = 0;
    this.researcherService.getWorkOrders(requestNbrs)
      .subscribe(
        (data) => {
          this.rpt = Report.getWorkOrderReport(data);
        });
  }
  notEndOfFile(value: string): boolean {
    if (this.jurisdiction === '' || this.jurisdiction === undefined || this.jurisdiction === null) {
      this.jurisdiction = value;
    }
    if (this.jurisdiction !== value) {
      this.jurisdiction = value;
      this.isPageBreak = true;
    } else {
      this.isPageBreak = false;
    }
    if (this.endOfFile !== 0) {
      this.endOfFile = this.endOfFile - 1;
    }
    return this.isPageBreak;
  }

  showJurisdiction(value: string): boolean {
   const show = localStorage.getItem('jurisdication');

   if (show !== null && show !== undefined && show !== '') {
      if (show === value) {
        this.showJuris = false;
      } else {
        this.showJuris = true;
      }
   } else {
     this.showJuris = true;
   }
    localStorage.setItem('jurisdiction', value);
    return this.showJuris;
  }
}



// WEBPACK FOOTER //
// ./src/app/workOrderReport/workOrderReport.component.ts